<ng-container *transloco="let t">
  <div class="admin-card">
    <app-admin-actions-header [isXlsVisible]="false" [isPdfVisible]="false">
      <div slot="leadingWidgets" class="d-flex flex-column flex-md-row">
        <div class="d-flex flex-column flex-md-row">
          <div class="w-216 d-flex align-items-center">
            <app-select
                    [hasDefault]="true"
                    [items]="statuses"
                    [ngModel]="selectedStatus"
                    [defaultValue]="undefined"
                    [defaultLabel]="t('app.common.all')"
                    class="me-2 mb-md-0 mb-2"
                    [valueKey]="'id'"
                    [labelKey]="'id'"
                    labelKeyPrefix="request.status."
                    (ngModelChange)="onStatusSelect($event)"
                    [leftAlign]="true"
                    [fullWidthDropdown]="true"
            />
          </div>

          @if (isAdministrator || isOrgAdministrator) {
          <div class="w-216 d-flex align-items-center">
            <app-select
              [hasDefault]="true"
              [items]="types"
              [ngModel]="selectedType"
              class="me-2 mb-md-0 mb-2"
              [defaultValue]="undefined"
              [defaultLabel]="t('app.common.all')"
              [valueKey]="'id'"
              [labelKey]="'id'"
              labelKeyPrefix="request.type."
              (ngModelChange)="onTypeSelect($event)"
              [leftAlign]="true"
              [fullWidthDropdown]="true"
            />
          </div>
          }
        </div>
      </div>
    </app-admin-actions-header>

    <app-loader [isLoading]="isLoading"></app-loader>

    @if (requests.length > 0) {
    <div>
      <!-- Desktop Table -->
      <div class="table-responsive dark-header d-xl-block d-none">
        <table class="table table-last-row-no-border">
          <thead>
            <tr>
                <th class="category-column-width">{{ t("request.category") }}</th>
                <th>{{ t("events.details.info") }}</th>
                <th class="date-column-width">{{ t("request.date.created") }}</th>
                <th class="status-column-width">{{ t("request.status") }}</th>
                <th class="more-column-width"></th>
              </tr>
            </thead>
            <tr app-table-header-separator></tr>
            <tbody>
              @for (request of requests; track request) {
    <tr>
      <!-- Category -->
      <td class="center-align">
        <div
                class="status-badge"
                [ngClass]="{
                        'on-hold': request.type === 2,
                        'accepted': request.type === 1,
                        'publishing': request.type === 0,
                        'blue': request.type === 3,
                      }"
        >
                      <span>
                        {{ t("request.type." + request.type) | uppercase }}
                      </span>
        </div>
      </td>
      <!-- Event or Organiser Name -->
      <td class="center-align">
        @if (request.type === RequestTypes.ORGANISER) {
          <p>
            @if (isAdministrator) {
              <span class="fw-600">{{(request.userDetail?.firstname ?? '') + ' ' + (request.userDetail?.lastname ?? '') }}</span>
              <span>{{ t('request.details.info.organiser.incoming') }}</span>
            } @else {
              <span>{{ t('request.details.info.organiser.outgoing') }}</span>
            }
          <p>
        }
        @else if (request.type === RequestTypes.PUBLISH_EVENT) {
          <p>
            @if (isAdministrator || isOrgAdministrator) {
            <span class="fw-600">{{request.organiserRequest?.name}}</span>
              <span>{{ t('request.details.info.publish.event.incoming') }}</span>
            } @else {
              <span>{{ t('request.details.info.publish.event.outgoing') }}</span>
            }
            <app-language-output
              class="fw-600"
              [hrLabel]="request.event?.name"
              [srLabel]="request.event?.nameSr"
              [enLabel]="request.event?.nameEng"
              [itLabel]="request.event?.nameIta"
              [siLabel]="request.event?.nameSlo"
              [bsLabel]="request.event?.nameBs"
              [defaultLanguage]="request.event?.defaultLanguage"
              [languages]="languages"
            />
          </p>
        }
        @else if (request.type === RequestTypes.PUBLISH_LEAGUE) {
          <p>
            @if (isAdministrator || isOrgAdministrator) {
              <span class="fw-600">{{request.organiserRequest?.name}}</span>
              <span>{{ t('request.details.info.publish.league.incoming') }}</span>
            } @else {
              <span>{{ t('request.details.info.publish.league.outgoing') }}</span>
            }
            <app-language-output
              class="fw-600"
              [hrLabel]="request.league?.name"
              [srLabel]="request.league?.nameSr"
              [enLabel]="request.league?.nameEng"
              [itLabel]="request.league?.nameIta"
              [siLabel]="request.league?.nameSlo"
              [bsLabel]="request.league?.nameBs"
              [defaultLanguage]="request.event?.defaultLanguage"
              [languages]="languages"
            />
          </p>
        }
        @else if (request.type === RequestTypes.ADD_EVENT_TO_LEAGUE) {
          <p>
            @if (listOfRequestsType === ListOfRequestsType.INCOMING) {
              <span class="fw-600">{{request.organiserRequest?.name}}</span>
              <span>{{ t('request.details.info.add.event.to.league.incoming1') }}</span>
            } @else {
              <span>{{ t('request.details.info.add.event.to.league.outgoing1') }}</span>
            }
            <app-language-output
              class="fw-600"
              [hrLabel]="request.event?.name"
              [srLabel]="request.event?.nameSr"
              [enLabel]="request.event?.nameEng"
              [itLabel]="request.event?.nameIta"
              [siLabel]="request.event?.nameSlo"
              [bsLabel]="request.event?.nameBs"
              [defaultLanguage]="request.event?.defaultLanguage"
              [languages]="languages"
            />
            @if (listOfRequestsType === ListOfRequestsType.INCOMING) {
              <span>{{ t('request.details.info.add.event.to.league.incoming2') }}</span>
            } @else {
              <span>{{ t('request.details.info.add.event.to.league.outgoing2') }}</span>
            }
            <app-language-output
              class="fw-600"
              [hrLabel]="request.league?.name"
              [srLabel]="request.league?.nameSr"
              [enLabel]="request.league?.nameEng"
              [itLabel]="request.league?.nameIta"
              [siLabel]="request.league?.nameSlo"
              [bsLabel]="request.league?.nameBs"
              [defaultLanguage]="request.event?.defaultLanguage"
              [languages]="languages"
            />
          </p>
        } @else {
          {{ "" }}
        }

      </td>
      <!-- Created Date -->
      <td class="center-align">{{ request.created | localizedDate: 'short' }}</td>

      <!-- Status Badge w/ Tooltip -->
      <td class="center-align">
        <div
                class="status-badge"
                [ngClass]="{
                        'on-hold': request.requestStatus === 0,
                        'accepted': request.requestStatus === 1,
                        'denied': request.requestStatus === 2
                      }"
                *ngIf="request.comment; else noTooltip"
                [ngbTooltip]="request.comment"
                [placement]="'left'"
        >
                      <span>
                        {{ t("request.status." + request.requestStatus) | uppercase }}
                      </span>
          <i class="bi bi-info-circle info-icon ps-2"></i>
        </div>
        <ng-template #noTooltip>
          <div
                  class="status-badge"
                  [ngClass]="{
                          'on-hold': request.requestStatus === 0,
                          'accepted': request.requestStatus === 1,
                          'denied': request.requestStatus === 2
                        }"
          >
                        <span>
                          {{ t("request.status." + request.requestStatus) | uppercase }}
                        </span>
          </div>
        </ng-template>
      </td>

      <td class="text-end center-align">
          <div class="d-flex justify-content-center align-items-center">
            <app-floating-icon-button
              [iconClass]="'fas fa-eye'"
              [addShadow]="false"
              (onClick)="openRequestDetails(request)"
            />
          </div>
      </td>
    </tr>
    }
    </tbody>
  </table>
</div>

<!-- Mobile Table -->
@for (request of requests; let isLast = $last; track request) {
    <div class="d-block d-xl-none">
      <div class="d-flex justify-content-center align-items-center mobile-table-row" [class.isLastRow]="isLast">
        <div class="flex-grow-1">
          <div class="d-flex flex-column" [class.isLastRow]="isLast">
            <div><strong>{{ t("request.category") }}:</strong> {{ " " + t("request.type." + request.type) }}</div>
            <div>
              <strong>{{ t("event.item.name") }}:</strong>
              @if (request.event) {
              <app-language-output
                [hrLabel]="request.event?.name"
                [srLabel]="request.event?.nameSr"
                [enLabel]="request.event?.nameEng"
                [itLabel]="request.event?.nameIta"
                [siLabel]="request.event?.nameSlo"
                [bsLabel]="request.event?.nameBs"
                [defaultLanguage]="request.event?.defaultLanguage"
                [languages]="languages"
              />
              } @else if (request.organiserRequest) {
              {{ request.organiserRequest.name }}
              } @else {
              {{ "" }}
              }
            </div>
            <div>
              <strong>{{ t("request.date.created") }}:</strong> {{ " " + request.created | localizedDate: 'short' }}
            </div>
            <div>
              <strong>{{ t("request.status") }}:</strong> {{ " " + t("request.status." + request.requestStatus) }}
            </div>
          </div>
        </div>

        <div>
          <span class="menu-icon" (click)="openRequestDetails(request)">
            <i class="fas fa-eye"></i>
          </span>
        </div>
      </div>
    </div>
    }
    </div>
    } @else {
    <div class="pt-2 pb-4">
      <app-empty-state />
    </div>
    }

    @if (hasMore) {
    <div class="d-flex justify-content-center load-more-wrapper pt-2 pb-2">
      <app-rounded-button [label]="t('app.common.load.more')" (onClick)="loadMore()" />
    </div>
    }

    @if (showFabButton && (requests?.length ?? 0) > 0) {
    <div (click)="scrollToTop()" class="scroll-to-top">
      <i class="bi bi-arrow-up"></i>
    </div>
    }
  </div>
</ng-container>

